import { isSameDay as isSame, isAfter, isBefore } from 'date-fns';

export const isSameDay = (firstDate: string, secondDate: string) =>
  isSame(new Date(firstDate), new Date(secondDate));

export const isAnyDayBefore = (firstDate: string, secondDate: string) => {
  const date1 = new Date(firstDate);
  const date2 = new Date(secondDate);

  // Time is not taken into consideration so we make sure the day values are not the same
  return !isSame(date1, date2) && isBefore(date1, date2);
};

export const isAnyDayAfter = (firstDate: string, secondDate: string) => {
  const date1 = new Date(firstDate);
  const date2 = new Date(secondDate);

  // Time is not taken into consideration so we make sure the day values are not the same
  return !isSame(date1, date2) && isAfter(date1, date2);
};

export const isAnyDayEqualOrBefore = (
  firstDate: string,
  secondDate: string
) => {
  const date1 = new Date(firstDate);
  const date2 = new Date(secondDate);

  return isSame(date1, date2) || isBefore(date1, date2);
};

export const isAnyDayEqualOrAfter = (firstDate: string, secondDate: string) => {
  const date1 = new Date(firstDate);
  const date2 = new Date(secondDate);

  return isSame(date1, date2) || isAfter(date1, date2);
};
